import React, { Component } from 'react';

/**
 * This function is used to Lazy Load a component.
 * 
 * https://scotch.io/tutorials/lazy-loading-routes-in-react
 * 
 * const CreateMyQuotationPage = asyncComponent(() =>
 *      import('./quotation/CreateMyQuotationPage').then(module => module.default)
 * )
 * 
 * @param {used to load the component} getComponent 
 */
export default function asyncComponent(getComponent) {
    class AsyncComponent extends Component {
        static Component = null
        state = { Component: AsyncComponent.Component }

        componentDidMount() {
            if (!this.state.Component) {
                getComponent().then(Component => {
                    AsyncComponent.Component = Component;
                    this.setState({ Component });
                });
            }
        }
        render() {
            const { Component } = this.state;
            if (Component) {
                return <Component {...this.props} />;
            }
            return null;
        }
    }
    return AsyncComponent;
}
